import { render } from "./VpnStatisticView.vue?vue&type=template&id=38373277&scoped=true"
import script from "./VpnStatisticView.vue?vue&type=script&lang=js"
export * from "./VpnStatisticView.vue?vue&type=script&lang=js"

import "./VpnStatisticView.vue?vue&type=style&index=0&id=38373277&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38373277"]])

export default __exports__